/*eslint-disable*/
"use strict";

exports.getConfigFormFieldsBillingAlertsNoMode = exports.getConfigFormFieldsBillingAlertsSwitchMode = exports.yearlyAreaChart = exports.last12AreaChart = exports.monthlyAreaChart = exports.diaryAreaChart = void 0;

var _validation = require("util/validation");

var MAX_LENGTH_TITLE = 128;
var diaryAreaChart = {
    chart: {
        type: 'areaspline',
        resetZoomButton: {
            position: {
                x: -5,
                y: -10
            },
            theme: {
                fill: '#fff'
            }
        },
        height: 200,
        // 350
        zoomType: 'x'
    },
    title: {
        text: null
    },
    yAxis: {
        title: null
    },
    xAxis: {
        gridLineWidth: 0,
        tickInterval: 1,
        labels: {
            formatter: function formatter() {
                return this.value;
            }
        },
        allowDecimals: false
    },
    legend: {
        enabled: false
    },
    tooltip: {
        shared: true,
        headerFormat: '',
        pointFormat: "<span style=\"color:{point.color}\">\u25CF</span> {series.name}: <b>${point.y:.2f}</b><br/>"
    },
    credits: {
        enabled: false
    },
    plotOptions: {
        areaspline: {
            pointStart: 1,
            stacking: 'normal',
            fillOpacity: 0.4,
            lineWidth: 1,
            marker: {
                radius: 3
            }
        },
        series: {
            cursor: 'pointer',
            trackByArea: true
        }
    },
    series: []
};
exports.diaryAreaChart = diaryAreaChart;
var monthlyAreaChart = {
    chart: {
        type: 'column',
        height: 200
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: []
    },
    yAxis: {
        min: 0,
        title: {
            text: ' '
        }
    },
    plotOptions: {
        column: {
            stacking: 'normal'
        }
    },
    legend: {
        enabled: false
    },
    tooltip: {
        shared: true,
        headerFormat: '',
        pointFormat: "<span style=\"color:{point.color}\">\u25CF</span> {series.name}: <b>${point.y:.2f}</b><br/>"
    },
    series: []
};
exports.monthlyAreaChart = monthlyAreaChart;
var last12AreaChart = {
    chart: {
        type: 'column',
        height: 200
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: [],
        labels: {
            autoRotation: [0],
            padding: '8px'
        }
    },
    yAxis: {
        min: 0,
        title: {
            text: ' '
        }
    },
    legend: {
        enabled: false
    },
    tooltip: {
        shared: true,
        headerFormat: '',
        pointFormat: "<span style=\"color:{point.color}\">\u25CF</span> {series.name}: <b>${point.y:.2f}</b><br/>"
    },
    plotOptions: {
        column: {
            stacking: 'normal'
        }
    },
    series: []
};
exports.last12AreaChart = last12AreaChart;
var yearlyAreaChart = {
    chart: {
        type: 'column',
        height: 200
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['2015', '2016', '2017', '2018']
    },
    yAxis: {
        min: 0,
        title: {
            text: ' '
        }
    },
    plotOptions: {
        column: {
            stacking: 'normal'
        }
    },
    legend: {
        enabled: false
    },
    tooltip: {
        shared: true,
        headerFormat: '',
        pointFormat: "<span style=\"color:{point.color}\">\u25CF</span> {series.name}: <b>${point.y:.2f}</b><br/>"
    },
    series: []
};
exports.yearlyAreaChart = yearlyAreaChart;

var getConfigFormFieldsBillingAlertsSwitchMode = function getConfigFormFieldsBillingAlertsSwitchMode(params, formatMessage, autoFocusField) {
    return [{
        type: 'text',
        name: 'name',
        label: formatMessage({
            id: 'label.billingAlerts.name'
        }),
        placeholder: formatMessage({
            id: 'label.billingAlerts.name.placeholder'
        }),
        errorClass: getFieldError(params.errorPost, 'name') ? 'has-error' : null,
        errorMessage: getFieldError(params.errorPost, 'name') ? formatMessage({
            id: getFieldError(params.errorPost, 'name')
        }) : null,
        validate: (0, _validation.joinValidators)([_validation.isEmpty, _validation.nonWhiteSpaces, (0, _validation.maxLength)(MAX_LENGTH_TITLE)]),
        autoFocus: getAutoFocus(autoFocusField === 'name' ? 'name' : null)
    }, {
        type: 'modalTableMultiselect',
        name: 'entities',
        disabled: !params.type,
        label: formatMessage({
            id: 'label.billingAlerts.entities'
        }),
        placeholder: 'label.billingAlerts.entities.placeholder',
        errorClass: getFieldError(params.errorPost, 'entities') ? 'has-error' : null,
        errorMessage: getFieldError(params.errorPost, 'entities') ? formatMessage({
            id: getFieldError(params.errorPost, 'entities')
        }) : null,
        modalTable: {
            closeOnSelect: false,
            options: {
                title: params.type ? formatMessage({
                    id: "form.billingAlerts.entities.modal.".concat(params.type.toLowerCase())
                }) : '',
                idFieldName: 'id',
                labelFieldName: 'name',
                descriptionFieldName: 'name',
                onAccept: params.onAcceptModal,
                container: params.type,
                selectedItems: params.selectedItems,
                extraData: {
                    mode: params.mode
                },
                sort: true,
                cancel: formatMessage({
                    id: 'label.button.cancel'
                }),
                placeholderClass: params.callerId ? '' : 'weight-normal'
            }
        }
    }, {
        type: 'switchField',
        name: 'mode',
        label: formatMessage({
            id: 'label.billingAlerts.mode'
        }),
        switchField: {
            options: {
                onText: 'Sum',
                offText: 'Multiple',
                onColor: '#7ab0eb',
                offColor: '$secondaryColorEquinix6',
                helpLabel: formatMessage({
                    id: getModeHelpText(params.mode)
                }),
                checked: params.mode,
                onChange: params.onSwitchChange
            }
        }
    }, {
        type: 'text',
        name: 'amount',
        typeInput: 'decimal',
        label: formatMessage({
            id: 'label.billingAlerts.amount'
        }),
        placeholder: formatMessage({
            id: 'label.billingAlerts.amount.placeholder'
        }),
        errorClass: getFieldError(params.errorPost, 'amount') ? 'has-error' : null,
        errorMessage: getFieldError(params.errorPost, 'amount') ? formatMessage({
            id: getFieldError(params.errorPost, 'amount')
        }) : null,
        validate: _validation.isEmpty,
        autoFocus: getAutoFocus(autoFocusField === 'amount' ? 'amount' : null)
    }, {
        type: 'extra',
        name: 'modeHelp',
        component: params.extra
    }, {
        type: 'list',
        name: 'cc',
        label: formatMessage({
            id: 'form.billingAlerts.cc.label'
        }),
        errorClass: getFieldError(params.errorPost, 'emails') ? 'has-error' : null,
        errorMessage: getFieldError(params.errorPost, 'emails') ? formatMessage({
            id: getFieldError(params.errorPost, 'emails')
        }) : null,
        validate: _validation.isEmpty,
        helpMessage: formatMessage({
            id: 'form.alerts.label.help'
        })
    }];
};

exports.getConfigFormFieldsBillingAlertsSwitchMode = getConfigFormFieldsBillingAlertsSwitchMode;

var getConfigFormFieldsBillingAlertsNoMode = function getConfigFormFieldsBillingAlertsNoMode(params, formatMessage) {
    return [{
        type: 'text',
        name: 'name',
        label: formatMessage({
            id: 'label.billingAlerts.name'
        }),
        placeholder: formatMessage({
            id: 'label.billingAlerts.name.placeholder'
        }),
        errorClass: getFieldError(params.errorPost, 'name') ? 'has-error' : null,
        errorMessage: getFieldError(params.errorPost, 'name') ? formatMessage({
            id: getFieldError(params.errorPost, 'name')
        }) : null,
        validate: (0, _validation.joinValidators)([_validation.isEmpty, _validation.nonWhiteSpaces, (0, _validation.maxLength)(MAX_LENGTH_TITLE)])
    }, {
        type: 'modalTableMultiselect',
        name: 'entities',
        disabled: !params.type,
        label: formatMessage({
            id: 'label.billingAlerts.entities'
        }),
        placeholder: 'label.billingAlerts.entities.placeholder',
        errorClass: getFieldError(params.errorPost, 'entities') ? 'has-error' : null,
        errorMessage: getFieldError(params.errorPost, 'entities') ? formatMessage({
            id: getFieldError(params.errorPost, 'entities')
        }) : null,
        modalTable: {
            closeOnSelect: false,
            options: {
                title: params.type ? formatMessage({
                    id: "form.billingAlerts.entities.modal.".concat(params.type.toLowerCase())
                }) : '',
                idFieldName: 'id',
                labelFieldName: 'name',
                descriptionFieldName: 'name',
                onAccept: params.onAcceptModal,
                container: params.type,
                selectedItems: params.selectedItems,
                extraData: {
                    mode: params.mode
                },
                sort: true,
                cancel: formatMessage({
                    id: 'label.button.cancel'
                }),
                placeholderClass: params.callerId ? '' : 'weight-normal'
            }
        }
    }, {
        type: 'text',
        name: 'amount',
        typeInput: 'decimal',
        label: formatMessage({
            id: 'label.billingAlerts.amount'
        }),
        placeholder: formatMessage({
            id: 'label.billingAlerts.amount.placeholder'
        }),
        errorClass: getFieldError(params.errorPost, 'amount') ? 'has-error' : null,
        errorMessage: getFieldError(params.errorPost, 'amount') ? formatMessage({
            id: getFieldError(params.errorPost, 'amount')
        }) : null,
        validate: _validation.isEmpty,
        autoFocus: true
    }, {
        type: 'extra',
        name: 'modeHelp',
        component: params.extra
    }, {
        type: 'list',
        name: 'cc',
        label: formatMessage({
            id: 'form.billingAlerts.cc.label'
        }),
        errorClass: getFieldError(params.errorPost, 'emails') ? 'has-error' : null,
        errorMessage: getFieldError(params.errorPost, 'emails') ? formatMessage({
            id: getFieldError(params.errorPost, 'emails')
        }) : null,
        validate: _validation.isEmpty,
        helpMessage: formatMessage({
            id: 'form.alerts.label.help'
        })
    }];
};

exports.getConfigFormFieldsBillingAlertsNoMode = getConfigFormFieldsBillingAlertsNoMode;

var getFieldError = function getFieldError(errorPost, field) {
    if (errorPost) {
        var fieldError = errorPost.find(function (item) {
            return item.field === field;
        });

        if (fieldError) {
            return fieldError.message;
        }
    }

    return null;
};

var getModeHelpText = function getModeHelpText(mode) {
    return mode ? 'label.billingAlerts.modeHelpSum' : 'label.billingAlerts.modeHelpBulk';
};

var getAutoFocus = function getAutoFocus(field) {
    if (field === 'name') {
        return true;
    } else if (field === 'amount') {
        return true;
    }

    return false;
};

/*eslint-enable*/



//////////////////
// WEBPACK FOOTER
// ./src/containers/cloud-billing/config/config.js
// module id = 864
// module chunks = 49